<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px; font-size: 16px">称重自动领料出库</div>
    <div class="filling-goods-head">
      <div class="filling-goods-head-div">
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">编号:</div>
          <input
            class="number"
            readonly="readonly"
            style="width: 80%"
            v-model="out_num"
          />
        </div>
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">卷号:</div>
          <input readonly="readonly" style="width: 80%" v-model="reeldata" />
        </div>
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">行数:</div>
          <input :value="datas.length" readonly="readonly" style="width: 80%" />
        </div>
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">货位:</div>
          <input v-model="goods_num" readonly="readonly" style="width: 80%" />
        </div>
      </div>
      <div class="filling-goods-head-div">
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">供应商:</div>
          <input :value="supplier_xh" readonly="readonly" style="width: 80%" />
        </div>
        <div class="head-input-div">
          <div style="width: 20%; text-align: left">现存量:</div>
          <input
            :value="count | getNoNull"
            name="normsware"
            readonly="readonly"
            style="width: 80%"
          />
        </div>
      </div>
    </div>
    <span style="color: red" v-if="hostcs">测试服</span>
    <div
      style="display: flex; justify-content: space-between; align-items: center"
      v-if="outNumber === '未出库'"
    >
      <van-button
        :text="ray"
        @click="holdRay()"
        size="small"
        style="display: flex"
        type="info"
      ></van-button>
      <div>
        <input
          @keyup.enter="goGck()"
          autocomplete="off"
          class="get-input"
          id="reel-input"
          readonly
          ref="getIDInpot"
          v-model="reeldata"
          v-on:blur="hideMessage('reeldata')"
        />
        <input
          @keyup.enter="add_mx(gck_number_data)"
          autocomplete="off"
          class="get-input"
          id="gck_number-input"
          readonly
          ref="getGCKInpot"
          v-model="gck_number_data"
          v-on:blur="hideMessage('gck_number_data')"
        />
      </div>
    </div>
    <div v-show="outNumber === '未出库'" style="text-align: left">
      <p>
        当前未出库 : 该卷布现存量为{{ count | getNoNull }}米 ,
        {{ weight | getNoNull }}公斤 , 称重得出裁剪后剩余为 (<input
          class="num"
          type="number"
          @keyup="inputUserNum"
          v-model="userNum"
        />)公斤 , 则裁剪出库为{{ tailoringOutbound | getNoNull }}米 ,
        出库后剩余的米数为 {{ (count - tailoringOutbound) | getNoNull }}米
      </p>
    </div>
    <div :style="style">
      <div :key="index" class="goods-info-two" v-for="(i, index) in datas">
        <div class="info-order-h">
          <span style="margin-right: 20px">{{
            i["gck_number"] || i["mxm"]
          }}</span>
          <span style="margin-right: 20px" v-show="i.hp_num">{{
            i.hp_num
          }}</span>
          <!--<span v-if="infoType === '1111'">{{i['num']}}米</span>-->
          <!--<span v-if="infoType === '1111'">* {{i['price']}}片 =</span>-->
          <span>
            <div v-if="outNumber === '未出库'">
              <input
                v-model="num"
                class="inputsItem"
                readonly
                v-on:blur="countAll()"
              />
              米
            </div>
            <div v-else>{{ num }}米</div>
          </span>
        </div>
        <div>
          <van-icon
            @click="deleteData(index, i['gck_number'])"
            name="cross"
            style="margin: 5px 0"
          />
        </div>
      </div>
    </div>
    <div style="text-align: left; font-size: 16px">共计{{ allcount }}米</div>
    <div class="filling-goods-bottom" style="display: flex">
      <van-button @click="go_index()" class="bottom-button" type="warning"
        >回首页</van-button
      >
      <van-button
        @click="fillingGoods()"
        class="bottom-button"
        type="info"
        v-if="outNumber === '未出库'"
        >确认出库</van-button
      >
      <van-button
        class="bottom-button"
        style="background-color: darkgray"
        type="default"
        v-if="outNumber !== '未出库'"
      >
        确认出库
      </van-button>
      <van-button
        @click="revocation(id)"
        class="bottom-button"
        type="info"
        v-if="outNumber !== '未出库'"
        >撤销出库</van-button
      >
      <van-button
        class="bottom-button"
        style="background-color: darkgray"
        type="default"
        v-if="outNumber === '未出库'"
      >
        撤销出库
      </van-button>
      <van-button
        @click="more_show = true"
        class="bottom-button"
        style="margin: 0"
        type="warning"
      >
        更多
      </van-button>
      <van-button
        class="bottom-button"
        type="warning"
        style="width: 10%"
        @click="resetClick()"
      >
        +
      </van-button>
    </div>
    <van-popup position="bottom" v-model="more_show">
      <div class="more-class">
        <van-icon @click="gourl('fillingGoods')" name="scan" size="1rem" />
      </div>
      <div class="more-class" style="padding: 10px 0">
        <span @click="all_delete()" style="font-size: 20px">整单删除</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { CheckboxGroup, Dialog, Toast } from "vant";

export default {
  name: "orderInfo",
  data() {
    return {
      hostcs: false,
      more_show: false,
      ray: "扫描中",
      id: "",
      supplier_xh: "",
      count: 0,
      datas: [],
      style: "",
      allcount: 0,
      reeldata: "",
      out_num: "",
      infoType: "1111",
      gck_number_data_haveAll: {},
      gck_number_data: "",
      fillingGoodsType: true,
      revocationType: true,
      outNumber: "未出库",
      username: "",
      gramWeight: "", // 克重
      meter: 0, // 米数
      weight: 0, // 重量
      userNum: "", // 用户输入的公斤数
      tailoringOutbound: "", // 裁剪出库米数
      num: 0,
      differ: 0, //相差的值
      counts: 0, //控制器
      type: "weightOutInfo",
      goods_num: "",
    };
  },
  computed: {
    getQomiNumnber() {
      return this.tailoringOutbound / this.datas.length;
    },
  },
  mounted() {
    this.counts++;
    this.username = JSON.parse(window.localStorage.getItem("userinfo"));
    if (this.$route.query.id !== undefined) {
      this.getIdData(this.$route.query.id);
    }
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
    setTimeout(() => {
      if (this.outNumber === "未出库") {
        this.focus();
      }
    }, 500);

    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
  },
  watch: {
    userNum(newValue, oldValue) {
      // 当这个值发生变化时
      // 裁剪出库米数要发生变化
      // 出库后的剩余米数 也要发生变化
      this.tailoringOutbound = this.count - newValue / (this.gramWeight / 1000);
      this.datas = this.datas.map((item) => {
        item.all_num = this.num;
        return item;
      });
      this.countAll();
    },
    datas() {
      if (this.counts === 1) {
        return;
      }
      this.num = this.getQomiNumnber.toFixed(2);
    },
  },
  methods: {
    resetClick() {
      // 重置
      if (this.outNumber === "未出库") {
        // 如果 未出库
        Dialog.confirm({
          title: "当前称重领料出库单未出库，是否要放弃当前出库单",
        }).then(() => {
          // 确认
          this.$router.push({ path: "/weightOutInfo" });
          window.location.reload();
        });
      } else {
        this.$router.push({ path: "/weightOutInfo" });
        window.location.reload();
      }
    },
    goGck() {
      this.get("/business/getNormsware", { reel: this.reeldata }).then(
        (res) => {
          this.datas.push(...res.data.bom_log);
        }
      );

      this.get("/business/getNormsware", { reel: this.reeldata }).then(
        (res) => {
          this.count = Number(res.data.store).toFixed(2);
          this.gramWeight = res.data["jhkz"]; // 克重
          this.weight = (this.gramWeight / 1000) * res.data["store"];
          if (Object.hasOwnProperty.call(res.data.goods, "goods_num")) {
            this.goods_num = res.data.goods.goods_num;
          }
        }
      );

      this.gck_input();
    },
    gck_input() {
      this.$refs.getGCKInpot.focus();
      this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getGCKInpot.removeAttribute("readonly");
      }, 200);
    },
    all_delete() {
      if (this.outNumber === "已出库") {
        Toast("已出库不能删除");
        return;
      }
      Dialog.confirm({
        message: "确定要删除当前出库单吗？",
      }).then(async () => {
        let s = await this.get(this.APIOBJ.outDel, {
          id: this.id,
          username: this.username,
        });
        Toast(s.data.msg);
        if (s.data.status === 1) {
          setTimeout(() => {
            this.$router.push("/home");
          }, 500);
        }
      });
    },
    countAll() {
      //计算总量
      this.allcount = 0;
      for (let i of this.datas) {
        this.allcount += parseFloat(i["all_num"]);
      }
      this.allcount = this.allcount.toFixed(1);
    },
    hideMessage(title) {
      if (title === "reeldata") {
        if (this.reeldata === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
      if (title === "gck_number_data") {
        if (this.gck_number_data === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
    },
    holdRay() {
      this.ray = "扫描中";
      if (this.reeldata === "") {
        this.focus();
      } else if (this.gck_number_data === "") {
        this.gck_input();
      }
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    gourl(url) {
      url = "http://www.lcyjfz.com/home/scan?url=" + url;
      window.location.href = url;
    },
    inputUserNum() {
      // 用户输入时 数值发生变化
      if (Number(this.userNum) > Number(this.weight)) {
        this.num = 0;
        Toast("超过最大值");
        return;
      }
      this.num = Number(this.getQomiNumnber.toFixed(2));
      this.tailoringOutbound =
        this.count - this.userNum / (this.gramWeight / 1000); //裁剪出库的米数
    },
    async add_mx(gck_number_title) {
      this.counts++;
      if (this.gck_number_data_haveAll[gck_number_title] !== undefined) {
        Toast("明细码不能重复");
        this.gck_number_data = "";
        return;
      }
      this.gck_number_data_haveAll[gck_number_title] = "";
      let packing = await this.get(this.APIOBJ.outOne, {
        reel: this.reeldata,
        gck_number: gck_number_title,
      });
      if (packing.data.status !== 0) {
        let newData = {};
        if (
          packing.data.data.gf === "沈矮峰" ||
          packing.data.data.gf === "沈高峰"
        ) {
          Dialog.confirm({
            cancelButtonText: "取消写入",
            confirmButtonText: "确认写入",
            showCancelButton: true,
            message:
              "系统没有匹配到，相应的型号，可能是下单人员，填写不工整，请您自行判断。是否要强制写入当前出库单",
          })
            .then(() => {
              newData["number"] = gck_number_title;
              newData["gck_number"] = gck_number_title;
              newData["all_num"] = this.num;
              this.datas.push(newData);
            })
            .catch(() => {
              delete this.gck_number_data_haveAll[gck_number_title];
            });
        } else {
          packing.data.data["gck_number"] = gck_number_title;
          packing.data.data["all_num"] = (
            packing.data.data["num"] * packing.data.data["price"]
          ).toFixed(1);
          packing.data.data["normsware"] = packing.data.data.normsware;
          packing.data.data["all_num"] = [
            ...document.querySelectorAll(".goods-info-two input"),
          ].reduce((all, el) => (all += Number(el.value)), 0);
          this.datas.push(packing.data.data);
          this.supplier_xh = packing.data.data["supplier_xh"];
        }
      } else {
        Toast(packing.data.msg);
      }

      this.gck_input();
      this.gck_number_data = "";
      this.datas = this.datas.map((item) => {
        item.all_num = this.getQomiNumnber;
        return item;
      });
      this.countAll();
    },
    deleteData(index, gck_number_data) {
      this.counts++;
      if (this.outNumber === "已出库") {
        Toast("已出库不能删除");
        return;
      }
      Dialog.confirm({
        message: "确定要删除该明细吗？",
      }).then(() => {
        let mxm = this.datas[index].mxm | this.datas[index].gck_number;
        this.datas.splice(index, 1);
        delete this.gck_number_data_haveAll[mxm];
        setTimeout(() => {
          this.countAll();
        }, 0);
      });
    },
    go_index() {
      Dialog.confirm({
        message: "确定要回首页吗？",
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
    async getIdData(id) {
      //订单详情页
      let idData = await this.get(this.APIOBJ.out_detail, { id });
      this.num = Number(idData.data.data.out_detail[0].num);
      this.supplier_xh = idData.data.data.out_detail[0].supplier_xh;
      this.datas = idData.data.data.out_detail.map((item) => {
        item.all_num = this.num;
        return item;
      });
      this.outNumber = idData.data.data.out.status;
      this.reeldata = idData.data.data.out_detail[0].reel;
      for (let i of idData.data.data.out_detail) {
        this.gck_number_data_haveAll[i.mxm] = "";
      }
      this.infoType = "";
      this.out_num = idData.data.data.out.out_num;
      this.userNum = idData.data.data.out.other; // 用户输入
      this.gramWeight = idData.data.data.out.jhkz; //克重
      this.allcount = idData.data.data.out_detail.reduce(
        (a, b) => (a += Number(b.num)),
        0
      );

      this.count = Number(idData.data.data.out.normsware).toFixed(2); // 现存量
      this.weight = ((this.gramWeight / 1000) * this.count).toFixed(2);
      this.tailoringOutbound = (this.count - this.userNum).toFixed(2);
      this.id = id;
      if (idData.data.data.out_detail.length) {
        this.goods_num = idData.data.data.out_detail[0].goods;
      }
    },
    async getFGIdData(FGid) {},
    async fillingGoods() {
      // if (this.datas.length === 0) {
      //   return;
      // }
      if (this.userNum.length === 0) {
        Toast("请输入剩余重量在出库");
        return;
      }
      if (!this.fillingGoodsType) {
        Toast("不要连续出库");
        return;
      }
      this.fillingGoodsType = false;
      let out_info;
      if (this.id === "") {
        let data = {
          reel: this.reeldata,
          gck_number: "",
          number: "",
          num: "",
          username: "",
          tailoringOutbound: "", // 用户输入的米数
          bom_id: "",
        };
        for (let i of this.datas) {
          if (i["all_num"] === "") {
            Toast("数量不能为空");
            this.fillingGoodsType = true;
            return;
          }
          data.gck_number += i.gck_number + ",";
          data.number += i.number + ",";
          data.num += document.querySelector(".inputsItem").value + ",";
        }
        data.username = this.username + ",";
        data.tailoringOutbound = this.userNum + "";
        data.bom_id =
          this.datas
            .filter((item) => item.hasOwnProperty("bom_id"))
            .map((item) => item.bom_id)
            .join(",") + ",";
        data.type = this.type;
        data.goods_num = this.goods_num;
        for (let i in data) {
          data[i] =
            data[i].substring(data[i].length - 1) === ","
              ? data[i].substring(0, data[i].length - 1)
              : data[i];
        }
        if (this.datas.length === 0) {
          data.num = Number(this.tailoringOutbound).toFixed(2);
        }
        out_info = await this.get(this.APIOBJ.doOut, data);
      } else {
        let data = {
          reel: this.reeldata,
          gck_number: "",
          number: "",
          num: "",
          id: this.id,
          username: "",
          tailoringOutbound: "", // 裁剪出库米数
          bom_id: "",
        };
        for (let i of this.datas) {
          if (i["all_num"] === "") {
            Toast(`${i.mxm}数量为空`);
            this.fillingGoodsType = true;
            return;
          }
          data.gck_number += (i.mxm || i.gck_number) + ",";
          data.number += i.number + ",";
          data.num += document.querySelector(".inputsItem").value + ",";
        }
        data.username = this.username + ",";
        data.tailoringOutbound = this.userNum + ",";
        data.goods_num = this.goods_num + "";
        data.type = this.type;
        data.bom_id =
          this.datas
            .filter((item) => item.hasOwnProperty("bom_id"))
            .map((item) => item.bom_id)
            .join(",") + ",";
        for (let i in data) {
          if (i !== "id") {
            data[i] =
              data[i].substring(data[i].length - 1) === ","
                ? data[i].substring(0, data[i].length - 1)
                : data[i];
          }
        }
        if (this.datas.length === 0) {
          data.num = Number(this.tailoringOutbound).toFixed(2);
        }
        out_info = await this.get(this.APIOBJ.outEdit, data);
      }
      if (out_info.data.status === 1) {
        Toast("成功");
      }else{
        Toast(out_info.data.msg)
      }
      this.id = out_info.data.data.out_detail[0].oid;
      this.fillingGoodsType = true;
      this.outNumber = out_info.data.data.out.status;
      this.infoType = "";
      this.out_num = out_info.data.data.out.out_num;
      this.datas = this.datas.map((item) => {
        item.all_num = this.num;
        return item;
      });
      this.countAll();
      this.count -= Number(this.allcount);
    },
    async revocation(id) {
      if (!this.revocationType) {
        return;
      }
      this.revocationType = false;
      // let bom_id = this.datas.filter((item) => item.bom_id).join(",") + ",";
      let bom_id = this.datas
        .filter((item) => item.bom_id)
        .map((item) => item.bom_id)
        .join(",");
      let out_info = await this.get(this.APIOBJ.backOut, {
        id: id,
        username: this.username,
        bom_id,
      });
      this.outNumber = "未出库";
      if (out_info.data.status === 1) {
        Toast("已撤销");
      }
      this.infoType = "1111";
      this.revocationType = true;
      this.count = Number(this.count) + Number(this.allcount);
      this.weight = Number(((this.gramWeight / 1000) * this.count).toFixed(2));
      this.tailoringOutbound = Number(
        (this.count - this.userNum / (this.gramWeight / 1000)).toFixed(2)
      ); //裁剪出库的米数
    },
  },
  filters: {
    getNoNull(value) {
      if (isNaN(value) || !value) {
        return 0;
      } else {
        return Number(value).toFixed(2);
      }
    },
  },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";
.num {
  border: none;
  width: 1.2rem;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>